/**
 *   Generated file. Do not edit
 */

import { LoraConfig } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getIds: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/lora/ids',
    path: '/1024//90',
  } as ServiceCallType<void, Uint8Array>,

  putIds: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/lora/ids',
    path: '/1024//90',
  } as ServiceCallType<Uint8Array, void>,

  getConfig: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/lora/config',
    path: '/1024//91',
    responseBodyDecoder: allConverters.loraConfig,
  } as ServiceCallType<void, LoraConfig>,

  putConfig: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/lora/config',
    path: '/1024//91',
    bodyEncoder: allConverters.loraConfig,
  } as ServiceCallType<LoraConfig, void>,
};
